import { HelpCircle } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";

interface EducationStatusFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  loading: boolean;
}

export function EducationStatusFields({
  profile,
  setProfile,
  readOnly,
  loading
}: EducationStatusFieldsProps) {
  const { t } = useTranslation("talent");

  return (
    <>
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">
            {t(
              "forms.sections.qualifications.fields.nursing_education_status.label"
            )}
          </label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>
                  {t(
                    "forms.sections.qualifications.fields.nursing_education_status.help"
                  )}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={profile?.nursing_education_status || "not_started"}
          onValueChange={(value) =>
            setProfile({
              ...profile!,
              nursing_education_status: value as any
            })
          }
        >
          <SelectTrigger loading={loading}>
            <SelectValue placeholder={t("forms.common.placeholders.select")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="not_started">
              {t("forms.common.nursing_education.not_started")}
            </SelectItem>
            <SelectItem value="in_progress">
              {t("forms.common.nursing_education.in_progress")}
            </SelectItem>
            <SelectItem value="completed">
              {t("forms.common.nursing_education.completed")}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      {profile?.nursing_education_status === "in_progress" && (
        <div className="space-y-1">
          <div className="flex items-center gap-1">
            <label className="text-sm font-medium">
              {t(
                "forms.sections.qualifications.fields.estimated_completion_date.label"
              )}
            </label>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <HelpCircle className="h-4 w-4 text-gray-400" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>
                    {t(
                      "forms.sections.qualifications.fields.estimated_completion_date.help"
                    )}
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <Input
            disabled={readOnly}
            loading={loading}
            type="date"
            value={profile.estimated_completion_date || ""}
            onChange={(e) =>
              setProfile({
                ...profile,
                estimated_completion_date: e.target.value
              })
            }
          />
        </div>
      )}
    </>
  );
}
